<p>
	{{ (permanent ? 'docs.templates.deletePermanent.content' : 'docs.templates.delete.content') | translate }}
</p>
<div class="list-limiter">
	@for (item of templates; track item) {
		<span class="mat-subtitle-2" class="mat-subtitle-2">
			{{ item.name }}
			<br />
		</span>
	}
</div>
